import React from "react";
import MobileProductLeadBlock from "./mobile-product-lead-block";
import DesktopProductLeadBlock from "./desktop-product-lead-block";
import type { ProductLeadBlockProps } from "../types";

const ProductLeadBlock = ({
  product,
  sidebarItems,
  pdpFixingToolTitle,
  pdpFixingToolDescription,
  pdpSpecificationTitle,
  pdpSpecificationDescription,
  documentDisplayFormat
}: ProductLeadBlockProps) => {
  return (
    <>
      <MobileProductLeadBlock
        product={product}
        sidebarItems={sidebarItems}
        pdpFixingToolTitle={pdpFixingToolTitle}
        pdpFixingToolDescription={pdpFixingToolDescription}
        pdpSpecificationDescription={pdpSpecificationDescription}
        pdpSpecificationTitle={pdpSpecificationTitle}
        documentDisplayFormat={documentDisplayFormat}
      />
      <DesktopProductLeadBlock
        product={product}
        sidebarItems={sidebarItems}
        pdpFixingToolTitle={pdpFixingToolTitle}
        pdpFixingToolDescription={pdpFixingToolDescription}
        pdpSpecificationDescription={pdpSpecificationDescription}
        pdpSpecificationTitle={pdpSpecificationTitle}
        documentDisplayFormat={documentDisplayFormat}
      />
    </>
  );
};
export default ProductLeadBlock;
